export default class Constants {

    //Fonts
    static FONT_BOLD = "font_bold";
    static FONT_REGULAR = "font_regular";

    // Player //
    static PLAYER_LIVES = 3;
}